// TODO: implement originator param
const nrSwitcherOn = (flags, project, event) => {
	const switcherRules = flags?.['ws-tagging-nr-switcher'];
	if (!switcherRules || !Array.isArray(switcherRules)) {
		// if no flag, allow reporting
		return true;
	}

	// turn off reporting only if project, event and originator match what we have specified in a rule
	// the flag is an array so we can combine rules
	const isOff = switcherRules.some(
		(rule) =>
			(rule.project === 'allProjects' || rule.project === project) &&
			(rule.event === 'allEvents' || rule.event === event)
		// && (
		//     rule.originator === 'allOriginators' ||
		//     rule.originator === originator
		// )
	);
	return !isOff;
};
export default nrSwitcherOn;
